export const errors = {
    namespaced: true,
    state: {
        errors: [],
    },
    getters: {
        getAll(state) {
            return state.errors;
        },
    },
    mutations: {
        add(state, message) {
            state.errors.push({
                message,
                open: true
            });
        },
        remove(state, index) {
            state.errors.splice(index, 1);
        },
    },
    actions: {
        put(context, payload) {
            context.commit('add', payload);
        },
        acknowledge(context, payload) {
            context.commit('remove', payload);
        }
    }
}